import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { addItems } from "../features/counter/counterSlice";
import IconButton from "@mui/material/IconButton";
import { keyframes } from "styled-components";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

function Course(props) {
  const history = useNavigate();
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [color] = useState("#e8c45f");
  const dispatch = useDispatch();
  const location = useLocation();

  const addItemsToBasket = () => {
    if (user?.email) {
      // const product = { props };
      const product = {
        affiliation: props.affiliation,
        courseImg: props.crsImg,
        description: props.description,
        duration: props.duration,
        id: props.id,
        name: props.title,
        price: props.price,
        state: props.state,
        stateColor: props.stColor,
        stateImg: props.stImg,
        stripePromo: props.promoCodeId,
        stripePrice: props.stripePriceId,
      };
      dispatch(addItems(product));
    } else {
      history("/login");
    }
    ///
  };

  const onClickSelectCourse = () => {
    if (location.state) {
      axios
        .post("/inviteToShare", {
          emails: props.users,
          teamId: props.teamId,
          courseId: props.id,
          fullName: user.fullName,
        })
        .then(() => {
          history("/team", {
            state: { clickStatus: "registration", teamId: props.teamId },
          });
        });
    }
  };

  const fetchUserCourses = async (userEmail) => {
    try {
      const res = await axios.post("/returnMyCourses", { userEmail });
      return res.data;
    } catch (err) {
      console.error("Ownership check failed:", err);
      return [];
    }
  };

  const [ownedCourseIds, setOwnedCourseIds] = useState(() => new Set());
  const [expiredSet,   setExpiredCourseIds] = useState(() => new Set());
  useEffect(() => {
    const fetchOwnedCourses = async () => {
      if(!user.email) return;

      const userCourses = await fetchUserCourses(user.email)
      const currentDate = new Date();

      // All owned course IDs
      const ownedSet = new Set(userCourses.map(c => c.courseId || c.id));

      // Course IDs that have at least ONE valid (non-expired) instance
      const validSet = new Set(
        userCourses
          .filter(c => !c.expiresOn || new Date(c.expiresOn) > currentDate)
          .map(c => c.courseId || c.id)
      )
      // Expired = owned but NOT valid
      const expiredSet = new Set([...ownedSet].filter(courseId => !validSet.has(courseId)));

      setOwnedCourseIds(ownedSet);
      setExpiredCourseIds(expiredSet);
    };
    fetchOwnedCourses();
  }, [user?.email]);

  const onMouseOverShowUpAddToCart = (event) => {

  };

  const onClickGoToCourse = () => {
    history("/mycourses");
  };

  return (
    <Container style={{ width: "225px",}}>
      <MultiButton>
        <AddToCartButton
          onClick={addItemsToBasket}
          title="Add to cart"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            className="bi bi-cart-plus-fill"
            viewBox="0 0 16 16"
          >
            <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9 5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 1 0z" />
          </svg>
        </AddToCartButton>
        <AddToFavoriteButton
          style={{ background: `${color}` }}
          title="Add to favorite"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-heart-fill"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
            />
          </svg>
        </AddToFavoriteButton>
        <DetailsButton style={{ background: `${color}` }} title="Read more">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-chat-fill"
            viewBox="0 0 16 16"
          >
            <path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z" />
          </svg>
        </DetailsButton>
        <CustomerService
          style={{ background: `${color}` }}
          title="Customer Service"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-send-fill"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"
            />
          </svg>
        </CustomerService>
      </MultiButton>

      <InlineContainer onClick={() => onClickSelectCourse()}>
        <TopMenu>
          <IconButtonContainer
            style={{ zIndex: "2" }}
            className="test_it"
            onMouseEnter={(e) => onMouseOverShowUpAddToCart(e)}
          >
            
            <IconButton aria-label="add to shopping cart" style={{ zIndex: "2" }} >
              <ShoppingCartIcon />
            </IconButton>
            <AddToCartPage>
              {props.isCourseAvailable 
                ? <AddToCartButton
                    onClick={addItemsToBasket}>
                    <AddShoppingCartIcon /> Add To Cart ...
                  </AddToCartButton>
                
                : <ComingSoonButton style={{ backgroundColor: "white", curson: "default" }}>
                    <AccessTimeIcon /> Coming Soon
                  </ComingSoonButton>
              }

              {(ownedCourseIds.has(props.id) && !expiredSet.has(props.id)) &&
                <DuplicateNotice>
                  <strong>NOTE:</strong> Account already owns a valid copy of this Course. 
                </DuplicateNotice>
              }

            </AddToCartPage>
          </IconButtonContainer>
        </TopMenu>
        <BottomContent>
          <StateImageContainer>
            <StateImage src={props.stImg}/>
            <StateColor style={{ backgroundColor: props.stColor }}>
              {(ownedCourseIds.has(props.id) && !expiredSet.has(props.id))
                ? <OwnedTest onClick={onClickGoToCourse}>
                    <LockOpenIcon/>Go to Course
                  </OwnedTest> 
                : (expiredSet.has(props.id)) 
                  ? <ExpiredTest onClick={addItemsToBasket}>
                      Expired - (${Number(props.price).toFixed(2)})
                    </ExpiredTest>
                  : <OwnedTest onClick={addItemsToBasket}>
                      ${Number(props.price).toFixed(2)}
                    </OwnedTest>
              }
            </StateColor>
          </StateImageContainer>
          <CourseTitle>{props.title}</CourseTitle>
          <CourseDuration>Estimated Duration: {props.duration}</CourseDuration>
          <CourseDetail>{props.description}</CourseDetail>
        </BottomContent>
      </InlineContainer>
    </Container>
  );
}

export default Course;

const OwnedTest = styled.button`
  border: none;
  background-color: #258E42;
  width: 100%;
  height: 100%;
  display: flex;                /* enable flexbox */
  align-items: center;          /* vertical centering */
  justify-content: center;      /* horizontal centering */
  gap: 4px;

  margin: 0 auto;
  font-size: 20px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;

  &:hover {
    font-size: 22px;
    background-color: #32B958;
    cursor: pointer;
  } */
`;

const ExpiredTest = styled.button`
  border: none;
  background-color: #FF3A51;
  width: 100%;
  height: 100%;
  display: flex;                /* enable flexbox */
  align-items: center;          /* vertical centering */
  justify-content: center;      /* horizontal centering */
  gap: 4px;

  margin: 0 auto;
  font-size: 20px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;

  &:hover {
    font-size: 22px;
    background-color: #FF6275;
    cursor: pointer;
  } */
`;



const BottomContent = styled.div`
  padding-bottom: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const MultiButton = styled.div`
  z-index: 0;
  position: absolute;
  top: 1.25rem;
  left: 1.25rem;
  border-radius: 100%;
  width: 0rem;
  height: 0rem;
  transform: translate(-50%, -50%);
  transition: 0.25s cubic-bezier(0.25, 0, 0, 1);
  button {
    display: grid;
    place-items: center;
    position: absolute;
    width: 2rem;
    height: 2rem;
    border: none;
    border-radius: 100%;
    background: #e8c45f;
    color: white;
    transform: translate(-50%, -50%);
    cursor: pointer;
    transition: 0.25s cubic-bezier(0.25, 0, 0, 1);
    box-shadow: 0 0 0rem -0.25rem #e8c45f;
    &:hover {
      background: #e8c45f;
      color: white;
      box-shadow: 0 0 1rem -0.25rem #e8c45f;
    }
    &:first-child:nth-last-child(1) {
      left: 25%;
      top: 25%;
    }
    &:first-child:nth-last-child(2),
    &:first-child:nth-last-child(2) ~ * {
      &:nth-child(1) {
        left: 37.5%;
        top: 18.75%;
      }
      &:nth-child(2) {
        left: 18.75%;
        top: 37.5%;
      }
    }
    &:first-child:nth-last-child(3),
    &:first-child:nth-last-child(3) ~ * {
      &:nth-child(1) {
        left: 50%;
        top: 15.625%;
      }
      &:nth-child(2) {
        left: 25%;
        top: 25%;
      }
      &:nth-child(3) {
        left: 15.625%;
        top: 50%;
      }
    }
    &:first-child:nth-last-child(4),
    &:first-child:nth-last-child(4) ~ * {
      &:nth-child(1) {
        left: 62.5%;
        top: 18.75%;
      }
      &:nth-child(2) {
        left: 37.5%;
        top: 18.75%;
      }
      &:nth-child(3) {
        left: 18.75%;
        top: 37.5%;
      }
      &:nth-child(4) {
        left: 18.75%;
        top: 62.5%;
      }
    }
  }
`;

const CourseTitle = styled.div`
  margin: 10px 10px 0px 10px;
  font-size: 1rem;
  text-align: left;
  font-weight: 600;
`;
const CourseDuration = styled.div`
  margin: 0px 10px 0px 10px;
  font-size: 0.6rem;
  text-align: justify;
  font-weight: 300;
  color: grey
`;
const CourseDetail = styled.div`
  margin: 0px 10px 0px 10px;
  font-size: 0.8rem;
  text-align: justify;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  max-height: 100px;
  padding: 0px 4px 0px 2px;
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;

  border-image: linear-gradient(
    to bottom,
    white 0%,
    white 30%,
    #e6e6e6 100%
  ) 1;
`;

const AddToFavoriteButton = styled.button``;
const DetailsButton = styled.button``;
const CustomerService = styled.button``;

const InlineContainer = styled.div`
  display: grid;
  grid-template-rows: 40px 1fr;
  z-index: 0;
  position: absolute;
  width: 100%;
  height: 100%;

  /* background: #f2f2f2; */
  background: white;
  color: black;
`;


const TopMenu = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;



const testAnimation = keyframes`
0% { transform: opacity: 0 !important; height:0% !important;}
100% { transform: opacity: 1 !important; height:100% !important;}
`;

const StateColor = styled.div`
  height: 100%;
  width: 100%;
  font-size: 1.2rem;
  opacity: 0;
  display: none;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
`;

const StateImage = styled.img`
  position: absolute;
  margin: 0 auto;
  height: 100px;
  width: 100%;
  object-fit: contain;
  opacity: 1;
  transform: scale(1);
  transition: all 0.2s ease-in-out;
`;

const StateImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
`;


const Container = styled.div`
  box-sizing: border-box;
  border: 2px solid #e6e6e6;
  background-color: white;
  border-radius: 5px;
  height: 300px;
  transition: all 1s ease-in-out;
  position: relative;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  &:hover {
    cursor: context-menu;
    ${StateImage} {
      opacity: 0;
    }

    ${StateColor} {
      opacity: 0.8;
    }
  }
`;

const DuplicateNotice = styled.div`
  margin: 10px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  transition: opacity 0.1s ease-in-out;
`;

const AddToCartPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  transition: opacity 0.8s ease-in-out, height 0.2s ease-in-out;
  opacity: 0;
  z-index: 1;
  border-radius: 2px;

`;

const AddToCartButton = styled.div`
  display: none;
  border: none;
  border-radius: 5px;
  padding: 5px;
  transition: all 0.2s ease-in-out;
  background-color: white;

  &:hover {
    cursor: pointer;
    background-color: #258e42 !important;
    color: white;
  }
`;

const ComingSoonButton = styled.div`
  display: none;
  border: none;
  border-radius: 5px;
  padding: 5px;
`;

const IconButtonContainer = styled.div`
  width: 40px;
  height: 40px;
  background-color: white;
  &:hover {
    ${AddToCartPage} {
      /* cursor: pointer; */
      /* { */
      /* z-index: 1 !important;
        position: absolute !important; */
      /* width: 100% !important;
        background-color: black !important; */
      opacity: 1 !important;
      /* transform: scale(1); */
      height: 100% !important;
      /* animation-name: ${testAnimation};
      animation-duration: 1s;
      animation-iteration-count: 1; */
    }

    ${AddToCartButton} {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ${ComingSoonButton} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
